import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, Row, Col, Label } from "reactstrap";
import { useSelector } from "react-redux";
import Layout from "../../components/Wrappers/Layout";
import val from "../../getThemeDetails";
import constants from "../../config/constants";


function VoucherManagement() {
  const { t } = useTranslation();

  const {
    data: { isMyBankAllowed, isMyWalletAllowed, isMyCardAllowed },
  } = useSelector(({ walletSetting }) => walletSetting);

  const getMappedListRes = useSelector(
    ({ getMappedList }) => getMappedList
  );
	const Theme = useSelector((state) => state.theme.theme);


  const history = useHistory();
  const { pathname } = useLocation();
  const options = [
    {
      id: 1,
      label: "Voucher Mapping",
      route: "/index/voucher-mapping",
      src: `${process.env.PUBLIC_URL}/${Theme}/voucher mapping.png`,
      flag: "VOUCHER MAPPING",
    },
    {
      id: 2,
      // label: "My Banks",
      label: "Voucher Transaction",
      route: "/index/voucher-transaction",
      src: `${process.env.PUBLIC_URL}/${Theme}/voucher transaction.png`,
      flag: "VOUCHER TRANSACTION",
    },
    {
      id: 3,
      label: "Vouchers",
      route: "/index/vouchers",
      src: `${process.env.PUBLIC_URL}/${Theme}/Voucher.png`,
      flag: "VOUCHERS",
    },
    // {
    //   id: 4,
    //   label: "My Wallets",
    //   route: "/index/my-wallets",
    //   src: `${process.env.PUBLIC_URL}/${val.theme}/MyWallets.png`,
    // },
    {
      id: 5,
      label: "Redeem",
      route: "/index/redeem",
      src: `${process.env.PUBLIC_URL}/${Theme}/redeem voucher.png`,
      flag: "REDEEM",
    },
  ];
  
  const filteredOptns = options.filter(({ label }) => {
    // if (
    //   label === "My Cards" && !constants.visibleFlags.includes(isMyCardAllowed)
    // ) {
    //   return label !== "My Cards";
    // }
    // else if (
    //   label === "My Banks" &&  !constants.visibleFlags.includes(isMyBankAllowed)
    // )
    // {
    //   return label !== "My Banks";
    // }
    if (
      label === "My Wallets" &&
      !constants.visibleFlags.includes(isMyWalletAllowed)
    ) {
      // return label !== "My Wallets";
    } else return true;
  });
  // .sort((a, b) => {
  //   return a.label > b.label ? 1 : -1;
  // });

  if (!filteredOptns.length) {
    return (
      <Layout>
        <Card className="mk-root">
          <Row className="mk-row m-auto">No My Accounts Available</Row>
        </Card>
      </Layout>
    );
  }

  const handleRoute = (route) => {
    history.push({ pathname: route, state: { from: pathname } });
  };

  return (
    <Layout>
      <Card className="mk-root">
        <Row className="mk-row">
          {options.map(({ id, src, label, route, flag }) => {
            if (
              getMappedListRes.success &&
              getMappedListRes.data.moduleAllocationVO.masterSubModuleMappingList.includes(flag)
            ) {
              return (<Col key={id} md={4} sm={4} xs={6}>
                <div className="mk-imageRoot" onClick={() => handleRoute(route)}>
                  <div className="mk-imageContainer">
                    <img className="mk-image" src={src} alt={label} />
                  </div>
                  <Label for={label} className="fs-14">
                    {t(label)}
                  </Label>
                </div>
              </Col>)
            }
          })}
        </Row>
      </Card>
    </Layout>
  );
}

export default VoucherManagement;
